import '../Logistic/logistic.css';
import '../Account/invoice.css';
import QRCode from 'react-qr-code';
import nmLogo from '.././../../assets/images/nm_logo.png';
import paymentQr from '.././../../assets/images/payment_qr.png';
import moment from 'moment';
import usePreventPrint from '../../../hooks/usePreventPrint';
import { Link, useLocation } from 'react-router-dom';
import { useContext, useEffect, useMemo, useState } from 'react';
import LoaderContext from '../../../context/loader/LoaderContext';
import 'react-toastify/dist/ReactToastify.css';
import AlertContext from '../../../context/Alert/AlertContext';
import axiosPrivate from '../../../hooks/axiosPrivate';
import { FaGreaterThan } from 'react-icons/fa';
import { toWordsPrice } from '../../../helpers/InWord';

const ViewOrderInvoice = ({ passData }) => {
  usePreventPrint();

  const location = useLocation();
  const { setIsLoading } = useContext(LoaderContext);
  // const passData = location.state || {};
  const [orders, setOrders] = useState(null);
  const data = {};
  function formatDate(inputDate) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    if (passData) {
      const filterOrders = passData?.orders?.filter((order) =>
        passData?.selectedItems?.splitId?.includes(order.split_id)
      );
      const updatedIds = filterOrders.map((order) => ({
        orderId: order.order_id,
        spliteMergeId: order.split_id || order.merge_id,
      }));
      axiosPrivate
        .post('accounting/view/invoice', {
          orders: updatedIds,
        })
        .then((response) => {
          console.log('passData====>', updatedIds);
          setOrders(response?.data?.data);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  }, [passData]);

  const info = useMemo(() => {
    const order = orders?.orders_items[0];
    return {
      address: `${order?.shipping_address} ,
    ${order?.shipping_city} ,
    ${order?.shipping_state} ,
    ${order?.shipping_zip}`,
      dealer: order?.name,
    };
  }, [orders]);

  const { quantity, totalAmount } = useMemo(() => {
    let quantity = 0;
    let totalAmount = 0;
    orders?.orders_items.forEach((item) => {
      quantity += Number(item?.dispatch_quantity);
      totalAmount += Number(
        Number(item.rate) * Number(item?.dispatch_quantity).toFixed(2)
      );
    });
    return { quantity, totalAmount };
  }, [orders]);

  const ordersNumber = useMemo(() => {
    return orders?.orders?.map((order) => `${order.order_no}`).join(', ');
  }, [orders?.orders]);

  const freight_amount = useMemo(() => {
    let amount = 0;
    const orderIds = [];
    orders?.orders_items.forEach((item) => {
      if (!orderIds.includes(item.order_id)) {
        amount += Number(item?.freight_amount || 0);
        orderIds.push(item.order_id);
      }
    });
    return amount;
  }, [orders]);

 const gst = useMemo(() => {
  let cgst = 0;
  let sgst = 0;
  let igst = 0;

  // Calculate the discount amount
  const discountValue =
    passData?.discount?.type === 'percentage'
      ? totalAmount * (passData?.discount?.value / 100)
      : passData?.discount?.value || 0;

  // Calculate the discounted total
  const discountedTotal = totalAmount - discountValue;

  // Calculate GST based on the discounted total
  orders?.orders_items.forEach((item) => {
    const itemAmount =
      (Number(item.rate) * Number(item.dispatch_quantity) * discountedTotal) /
      totalAmount;

    if (item?.shipping_state?.toLowerCase() === 'rajasthan'.toLowerCase()) {
      let cgstRate = Number(item.cgst_rate);
      let sgstRate = Number(item.sgst_rate);
      const cgstAmount = ((itemAmount * cgstRate) / 100).toFixed(2);
      const sgstAmount = ((itemAmount * sgstRate) / 100).toFixed(2);
      cgst += Number(cgstAmount);
      sgst += Number(sgstAmount);
    } else {
      let igstRate = Number(item?.igst_rate) || 0;
      const igstAmount = ((itemAmount * igstRate) / 100).toFixed(2);
      igst += Number(igstAmount);
    }
  });

  return { igst, cgst, sgst, discountedTotal };
}, [orders, totalAmount, passData]);

  console.log('gst=====>', gst);

  return (
    <>
      <div className='section-body'>
        <div className='container-fluid'>
          {/* <div className='card-header'>
            <strong className='top-left-heading'> Splited Order Items</strong>

            <ol className='headerroutes breadcrumb m-0 bg-none '>
              <li className='item color-gray'>|</li>
              <li className='item'>
                <Link to='/admin/dashboard' className='route-heading item mx-2'>
                  Dashboard
                </Link>
              </li>
              <li className='item'>
                <FaGreaterThan className='grater-than-route' />
              </li>
              <li className='route-heading item mx-2 mt-1'>
                <Link to='/admin/dispatch'>Dispatch</Link>
              </li>
              <li className='item'>
                <FaGreaterThan className='grater-than-route' />
              </li>

              <li className='route-heading item mx-2 mt-1'> View Invoice</li>
            </ol>
          </div> */}
          <div className='tab-content '>
            <div
              className='tab-pane fade show active'
              id='user-list'
              role='tabpanel'
            >
              <div className='card'>
                {' '}
                <div className='card-body'>
                  <div className='jumBotron invoice-container'>
                    <div className='header-invoice'>
                      <div>
                        <div className='header-in d-flex align-items-center'>
                          <div style={{ width: '190px' }}>
                            <img src={nmLogo} alt='NM Logo' />
                          </div>
                          <div className='right-sec'>
                            <h6 className='tax-heading'>Tax Invoice</h6>
                            <h3 className='company_name'>
                              NM India Bio Private Limited
                            </h3>
                            <div className='invoice-address'>
                              Araji No. 4790, Jhamar Kotra Road, Umarda, Udaipur
                              , Rajasthan - 313003, INDIA.
                            </div>
                            <div className='my-0 invoice-address '>
                              <span>9829355044</span>
                              <span className='mx-3'>
                                bhanuprakash@nmidiabio.com
                              </span>
                            </div>
                            <div className='invoice-address'>
                              <span>
                                GSTIN: <b>08AACCE7746A1ZT</b>
                              </span>
                              <span className='mx-3'>
                                PAN: <b>AACCE7746A</b>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className='invoice-bill mt-3'>
                            <div className='invoice-bill-content'>
                              <div className='invoice-date'>
                                <span>INVOICE</span>
                                <br></br>
                                <span>{data?.vch_no}</span>
                                <br></br>
                                <span>
                                  {formatDate(orders?.orders[0]?.order_date)}
                                </span>
                              </div>
                              <div className='invoice-person-detail'>
                                <p style={{ marginBottom: '0' }}>Bill to</p>
                                <div className='tax-heading'>{info.dealer}</div>
                                <span>Dealer Code : </span>
                                <br></br>
                                <span>{info?.address}</span>
                                <br></br>
                                <span>
                                  GSTIN : {data?.parsedReplacements?.gstin} (24){' '}
                                  {data?.parsedReplacements?.billing_state}
                                </span>
                              </div>
                            </div>
                            <div
                              className='invoice-person-detail'
                              style={{ borderLeft: '1px solid black' }}
                            >
                              <p style={{ marginBottom: '0' }}>Ship to</p>
                              <div className='tax-heading'>{info.dealer}</div>
                              <span>Dealer Code : </span>
                              <br></br>
                              <span>{info.address}</span>
                              <br></br>
                              <span>
                                GSTIN : {data?.parsedReplacements?.gstin} (24){' '}
                                {data?.parsedReplacements?.shipping_state}
                              </span>
                            </div>
                            <div className='invoice-bill-qrcode'>
                              <img src={paymentQr} style={{ width: '100px' }} />
                            </div>
                          </div>

                          <table className='mid-line-table'>
                            <tr>
                              <th className='first-th'>IRN</th>
                              <th>{data?.parsedReplacements?.ewayBill?.irn}</th>
                              <th>
                                {data?.parsedReplacements?.ewayBill?.irnAckNo}
                              </th>
                              <th>
                                @ {formatDate(orders?.orders[0]?.order_date)}
                              </th>
                            </tr>
                          </table>

                          <table>
                            <tr>
                              <th></th>
                              <th>Order</th>
                              <th>Dispatch Doc</th>
                              <th>Through</th>
                              <th>LR/RR/BL</th>
                              <th>Carrier</th>
                            </tr>

                            <tr>
                              <td>#</td>
                              <td>{ordersNumber}</td>
                              <td>{data?.vch_no}</td>
                              <td>
                                {orders?.orders_items[0]?.transporter_name}
                              </td>
                              <td>{orders?.orders_items[0]?.lr_no}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>@</td>
                              <td>
                                {formatDate(orders?.orders[0]?.order_date)}
                              </td>
                              <td></td>
                              <td></td>
                              <td className='date'>
                                {formatDate(orders?.orders[0]?.order_date)}{' '}
                              </td>
                              <td>{data?.parsedReplacements?.carrierNumber}</td>
                            </tr>
                          </table>

                          <table className='main-table'>
                            <thead>
                              <tr>
                                <th className='s_no'>S.No</th>
                                <th className='product_name_td'>
                                  Description of Goods
                                </th>
                                <th className='hsn_td1'>HSN</th>
                                <th>Quantity</th>
                                <th>Weight</th>
                                <th>Carton</th>
                                <th>Rate</th>
                                <th>Per</th>
                                <th>Disc. %</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {orders?.orders_items?.map((product, index) => (
                                <>
                                  <tr className='border-0' key={index}>
                                    <td>{index + 1}</td>
                                    <td className='product_name_td'>
                                      {product.product_name}
                                    </td>
                                    <td>310100</td>
                                    <td>{`${product?.dispatch_quantity} ${product?.base_unit}`}</td>
                                    <td>{`${product?.weight} ${product?.unit}`}</td>
                                    <td>-</td>
                                    <td>{`${product.rate}.00`}</td>
                                    <td>{product.base_unit}</td>
                                    <td>-</td>
                                    <td>
                                      {(
                                        Number(product.rate) *
                                        Number(product?.dispatch_quantity)
                                      ).toFixed(2)}
                                    </td>
                                  </tr>
                                </>
                              ))}
                              <tr
                                className='border-0'
                                style={{ height: '30px' }}
                              >
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <b>-</b>
                                </td>
                              </tr>

                              {passData?.discount?.value > 0 && (
                                <tr className='border-0'>
                                  <td></td>
                                  <td
                                    className='d-flex justify-content-between'
                                    style={{ paddingRight: '5px' }}
                                  >
                                    <b></b>
                                    <b>
                                      <i>{passData?.discount?.name}</i>
                                    </b>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>
                                    <b>
                                     
                                      {passData?.discount?.type === 'percentage' ? (
                                        totalAmount *
                                        (passData?.discount?.value / 100)
                                      ).toFixed(1) : (
                                        passData?.discount?.value
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              )}

                              {gst?.cgst > 0 && (
                                <tr className='border-0'>
                                  <td></td>
                                  <td
                                    className='d-flex justify-content-between'
                                    style={{ paddingRight: '5px' }}
                                  >
                                    <b></b>
                                    <b>
                                      <i>CGST</i>
                                    </b>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>
                                    <b>{gst?.cgst}</b>
                                  </td>
                                </tr>
                              )}
                              {gst?.sgst > 0 && (
                                <tr className='border-0'>
                                  <td></td>
                                  <td
                                    className='d-flex justify-content-between'
                                    style={{ paddingRight: '5px' }}
                                  >
                                    <b></b>
                                    <b>
                                      <i>SGST</i>
                                    </b>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>
                                    <b>{gst?.sgst}</b>
                                  </td>
                                </tr>
                              )}
                              {gst?.igst > 0 && (
                                <tr className='border-0'>
                                  <td></td>
                                  <td
                                    className='d-flex justify-content-between'
                                    style={{ paddingRight: '5px' }}
                                  >
                                    <b></b>
                                    <b>
                                      <i>IGST</i>
                                    </b>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>
                                    <b>{(gst?.igst).toFixed(2)}</b>
                                  </td>
                                </tr>
                              )}

                              <tr
                                style={{ height: '200px' }}
                                className='border-0'
                              >
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  <b>Total Amount</b>
                                </td>
                                <td></td>
                                <td>
                                  <b>
                                    {quantity}{' '}
                                    {data?.parsedReplacements?.baseUnit}
                                  </b>
                                </td>
                                <td>
                                  {data?.parsedReplacements?.total_weight}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <b>
                                    Rs.{' '}
                                    {(
                                      totalAmount - gst.discountedTotal + 
                                      Object.values(gst || {}).reduce(
                                        (acc, curr) => acc + curr,
                                        0
                                      ) -
                                      (passData?.discount?.type === 'percentage' ? (
                                        gst.discountedTotal *
                                        (passData?.discount?.value / 100)
                                      ) : (
                                        passData?.discount?.value
                                      ) || 0)
                                    ).toFixed(2)}
                                  </b>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <table className='amount-chargeble'>
                            <tbody>
                              <div
                                className='d-flex'
                                style={{
                                  borderLeft: '1px solid #000',
                                  borderRight: '1px solid #000',
                                }}
                              >
                                <div
                                  style={{
                                    borderRight: '1px solid #000',
                                    width: '80%',
                                    padding: '0px 5px',
                                  }}
                                >
                                  <div className='d-flex justify-content-between amount-words'>
                                    <p className='m-0 amount'>
                                      <b>Amount Chargeable (In words)</b>
                                    </p>
                                    <p className='mx-1 mb-0 eof text-right'>
                                      <b>E. & O.E</b>
                                    </p>
                                  </div>
                                  <div className='mb-0 amount-eng'>
                                    <b>
                                      INR{' '}
                                      {toWordsPrice(
                                         totalAmount - gst.discountedTotal + 
                                         Object.values(gst || {}).reduce(
                                           (acc, curr) => acc + curr,
                                           0
                                         ) -
                                         (passData?.discount?.type === 'percentage' ? (
                                           gst.discountedTotal *
                                           (passData?.discount?.value / 100)
                                         ) : (
                                           passData?.discount?.value
                                         ) || 0)
                                      ).toUpperCase()}
                                    </b>
                                  </div>
                                  <p></p>
                                </div>

                                <div
                                  style={{ padding: '0px 5px', margin: 'auto' }}
                                >
                                  <div className='d-flex justify-content-between'>
                                    <b>Freight Payable :</b>
                                    <b style={{ paddingLeft: '5px' }}>
                                      {' '}
                                      {freight_amount}
                                      .00
                                    </b>
                                  </div>
                                  <div className='d-flex justify-content-between'>
                                    <b>Due Amount :</b>
                                    <b style={{ paddingLeft: '5px' }}> 00.00</b>
                                  </div>
                                </div>
                              </div>
                            </tbody>
                          </table>

                          <table className='tax-amount'>
                            <thead>
                              <tr>
                                <th style={{ textAlign: 'center' }}>HSN/SAC</th>
                                <th
                                  style={{ width: '15%', textAlign: 'center' }}
                                >
                                  Taxable Value
                                </th>
                                {gst?.cgst > 0 && (
                                  <th className='p-0' style={{ width: '15%' }}>
                                    <div
                                      className='text-center'
                                      style={{ borderBottom: '1px solid #000' }}
                                    >
                                      <b style={{ fontWeight: 'bold' }}>
                                        Central Tax
                                      </b>
                                    </div>
                                    <div className='d-flex justify-content-around'>
                                      <b
                                        style={{
                                          fontWeight: 'bold',
                                          padding: '0px 5px',
                                          width: '53px',
                                        }}
                                      >
                                        Rate
                                      </b>
                                      <b
                                        style={{
                                          borderRight: '1px solid #000',
                                        }}
                                      ></b>
                                      <b
                                        style={{
                                          fontWeight: 'bold',
                                          padding: '0px 5px',
                                        }}
                                      >
                                        Amount
                                      </b>
                                    </div>
                                  </th>
                                )}

                                {gst?.sgst > 0 && (
                                  <th className='p-0' style={{ width: '15%' }}>
                                    <div
                                      className='text-center'
                                      style={{ borderBottom: '1px solid #000' }}
                                    >
                                      <b style={{ fontWeight: 'bold' }}>
                                        State Tax
                                      </b>
                                    </div>
                                    <div className='d-flex justify-content-around'>
                                      <b
                                        style={{
                                          fontWeight: 'bold',
                                          padding: '0px 5px',
                                          width: '53px',
                                        }}
                                      >
                                        Rate
                                      </b>
                                      <b
                                        style={{
                                          borderRight: '1px solid #000',
                                        }}
                                      ></b>
                                      <b
                                        style={{
                                          fontWeight: 'bold',
                                          padding: '0px 5px',
                                        }}
                                      >
                                        Amount
                                      </b>
                                    </div>
                                  </th>
                                )}

                                {gst?.igst > 0 && (
                                  <th className='p-0' style={{ width: '15%' }}>
                                    <div
                                      className='text-center'
                                      style={{ borderBottom: '1px solid #000' }}
                                    >
                                      <b style={{ fontWeight: 'bold' }}>
                                        Integrated Tax
                                      </b>
                                    </div>
                                    <div className='d-flex justify-content-around'>
                                      <b
                                        style={{
                                          fontWeight: 'bold',
                                          padding: '0px 5px',
                                          width: '53px',
                                        }}
                                      >
                                        Rate
                                      </b>
                                      <b
                                        style={{
                                          borderRight: '1px solid #000',
                                        }}
                                      ></b>
                                      <b
                                        style={{
                                          fontWeight: 'bold',
                                          padding: '0px 5px',
                                        }}
                                      >
                                        Amount
                                      </b>
                                    </div>
                                  </th>
                                )}
                                <th
                                  style={{ width: '15%', textAlign: 'center' }}
                                >
                                  Total Tax Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ textAlign: 'center' }}>310100</td>
                                <td
                                  style={{ width: '15%', textAlign: 'center' }}
                                >
                                  {gst.discountedTotal}
                                </td>

                                {gst?.cgst > 0 && (
                                  <>
                                    <td
                                      className='p-0'
                                      style={{ width: '15%' }}
                                    >
                                      <div className='d-flex justify-content-around'>
                                        <div
                                          style={{
                                            fontWeight: 'none',
                                            padding: '0px 5px',
                                          }}
                                        >
                                          {(
                                            (gst?.cgst * 100) /
                                            gst.discountedTotal
                                          ).toFixed(1)}
                                          %
                                        </div>
                                        <div
                                          style={{
                                            borderRight: '1px solid #000',
                                          }}
                                        ></div>
                                        <div style={{ padding: '0px 5px' }}>
                                          {gst.cgst}
                                        </div>
                                      </div>
                                    </td>
                                  </>
                                )}

                                {gst?.sgst > 0 && (
                                  <>
                                    <td
                                      className='p-0'
                                      style={{ width: '15%' }}
                                    >
                                      <div className='d-flex justify-content-around'>
                                        <div
                                          style={{
                                            fontWeight: 'none',
                                            padding: '0px 5px',
                                          }}
                                        >
                                          {(
                                            (gst?.sgst * 100) /
                                            gst.discountedTotal
                                          ).toFixed(1)}
                                          %
                                        </div>
                                        <div
                                          style={{
                                            borderRight: '1px solid #000',
                                          }}
                                        ></div>
                                        <div style={{ padding: '0px 5px' }}>
                                          {gst.sgst}
                                        </div>
                                      </div>
                                    </td>
                                  </>
                                )}

                                {gst?.igst > 0 && (
                                  <>
                                    <td
                                      className='p-0'
                                      style={{ width: '15%' }}
                                    >
                                      <div className='d-flex justify-content-around'>
                                        <div
                                          style={{
                                            fontWeight: 'none',
                                            padding: '0px 5px',
                                          }}
                                        >
                                          {(
                                            (gst?.igst * 100) /
                                            gst.discountedTotal
                                          ).toFixed(1)}
                                          %
                                        </div>
                                        <div
                                          style={{
                                            borderRight: '1px solid #000',
                                          }}
                                        ></div>
                                        <div style={{ padding: '0px 5px' }}>
                                          {}
                                        </div>
                                      </div>
                                    </td>
                                  </>
                                )}

                                <td
                                  style={{ width: '15%', textAlign: 'center' }}
                                >
                                  {(Object.values(gst || {}).reduce(
                                    (acc, curr) => acc + curr,
                                    0
                                  )-gst.discountedTotal).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div className='pt-2 pl-1 bank_details d-flex justify-content-between border border-dark'>
                            <div className='d-flex flex-column justify-content-between w-50 pr-4'>
                              <span>
                                Tax Amount (in Words) :<br />
                                <b>
                                  INR{' '}
                                  {toWordsPrice(
                                    Object.values(gst || {}).reduce(
                                      (acc, curr) => acc + curr,
                                      0
                                    ) - gst.discountedTotal
                                  ).toUpperCase()}
                                </b>
                                {/* <!-- Enter amount in words  --> */}
                              </span>
                              <div>
                                <p className='mb-0 pt-2'>
                                  <p
                                    className='mb-0'
                                    style={{ textDecoration: 'underline' }}
                                  >
                                    Declaration :
                                  </p>
                                  We Declare that this invoice shows the real
                                  price of the goods described and that all
                                  particular true and correct.
                                </p>
                              </div>
                            </div>
                            <div className='company_div w-50'>
                              <div className='mt-0'>
                                <p className='mb-0'>Company's Bank Details</p>
                                <p className='mb-0'>
                                  Bank Name : <b>Bank of Baroda (India)</b>
                                </p>
                                <p className='mb-0'>
                                  A/c No. : <b>01370500000868</b>
                                </p>
                                <p className='mb-0'>
                                  Branch & IFSC Code :{' '}
                                  <b>Udaipur Main Branch & BARB0UDAIPU</b>
                                </p>
                              </div>
                              <div
                                className='invoice-bill-qrcode qr-code border border-dark w-100 h-100 p-1'
                                style={{ borderBottom: '0px !important' }}
                              >
                                <div>
                                  <div className='text-left'>
                                    <b>Scan to Pay</b>
                                  </div>
                                  <div className='mt-1'>
                                    <img
                                      src={paymentQr}
                                      style={{ width: '100px' }}
                                    />
                                  </div>
                                </div>
                                <div className='d-flex flex-column justify-content-between mt-3'>
                                  <p style={{ fontWeight: '600' }}>
                                    For{' '}
                                    <span style={{ fontWeight: 'bold' }}>
                                      NM India Bio Private Limited
                                    </span>{' '}
                                  </p>
                                  <p className='mb-0'>Authorized Signatory</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='border border-dark text-center p-2 border-top-0'>
                            This is a computer generated Invoice
                          </div>

                          {data?.parsedReplacements?.ewayBill && (
                            <>
                              {/* Add this div to introduce a page break */}
                              <div className='pageBreak'></div>
                              <div className=' p-0 mt-4'>
                                <div className='header bg-none'>
                                  <h6>e-Way Bill</h6>
                                </div>

                                <div className='invoiceSectionBorderBottom'>
                                  <div>
                                    <p>
                                      Doc No :{' '}
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.docNo
                                        }
                                      </span>
                                    </p>
                                    <p>
                                      Date :
                                      <span className='boldText'>
                                        {' '}
                                        {moment(
                                          data?.parsedReplacements?.ewayBill
                                            ?.billDate,
                                          'YYYYMMDD'
                                        ).format('DD-MMM-YYYY')}
                                      </span>
                                    </p>
                                    <p>
                                      IRN :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.irn
                                        }
                                      </span>
                                    </p>
                                    <p>
                                      Ack No :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.irnAckNo
                                        }
                                      </span>
                                    </p>
                                    <p>
                                      Ack Date :
                                      <span className='boldText'>
                                        {' '}
                                        {moment(
                                          data?.parsedReplacements?.ewayBill
                                            ?.irnAckDate,
                                          'YYYYMMDD'
                                        ).format('DD-MMM-YYYY')}
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    {' '}
                                    <QRCode
                                      title='GeeksForGeeks'
                                      value={
                                        data?.parsedReplacements?.ewayBill
                                          ?.qrCode
                                      }
                                      bgColor={'#ffffff'}
                                      fgColor={'#000000'}
                                      size={100}
                                    />
                                  </div>
                                </div>

                                {/* <h3>1. e-Way Bill Details</h3> */}
                                <div className='boldText p-1'>
                                  1. e-Way Bill Details
                                </div>
                                <div className='invoiceSectionBorderBottom'>
                                  <div>
                                    <p>
                                      e-Way Bill No :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.billNumber
                                        }
                                      </span>
                                    </p>
                                    <p>
                                      Generated By :
                                      <span className='boldText'>
                                        {' '}
                                        08AACCE7746A1ZT
                                      </span>
                                    </p>
                                    <p>
                                      Supply Type :
                                      <span className='boldText'> Outward</span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      Mode :
                                      <span className='boldText'> 1-Road</span>
                                    </p>
                                    <p>
                                      Approx Distance :
                                      <span className='boldText'>
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.approxDistance
                                        }
                                      </span>
                                    </p>
                                    <p>
                                      Transition Type :
                                      <span className='boldText'>
                                        {' '}
                                        Bill To - Ship To
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      Generated Date :
                                      <span className='boldText'>
                                        {moment(
                                          data?.parsedReplacements?.ewayBill
                                            ?.generatedDate,
                                          'YYYYMMDD'
                                        ).format('DD-MMM-YYYY')}
                                      </span>
                                    </p>
                                    <p>
                                      Valid Upto :
                                      <span className='boldText'>
                                        {' '}
                                        {moment(
                                          data?.parsedReplacements?.ewayBill
                                            ?.validUpto,
                                          'YYYYMMDD'
                                        ).format('DD-MMM-YYYY')}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                                {/* <h3>2. Address Details</h3> */}
                                <div className='boldText p-1'>
                                  2. Address Details
                                </div>
                                <div className='rows'>
                                  <div className='column1'>
                                    <div className='p-1'>
                                      <p>
                                        <span className='boldText'>From </span>
                                      </p>
                                      <p>NM India Bio Private Limited</p>
                                      <p>GSTIN: 08AACCE7746A1ZT</p>
                                      <p>
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.shipFromAddress
                                        }
                                      </p>
                                    </div>
                                    <div className='p-1'>
                                      <p>
                                        <span className='boldText'>
                                          Dispatch From
                                        </span>
                                      </p>
                                      <p>
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.consignorAddress
                                        }
                                        {', '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.consignorCity
                                        }{' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.shipFromAddress
                                        }{' '}
                                        {data?.parsedReplacements?.billing_zip}
                                      </p>
                                    </div>
                                  </div>
                                  <div className='column2'>
                                    <div>
                                      <p>
                                        <span className='boldText'>To</span>
                                      </p>
                                      <p>
                                        {
                                          data?.parsedReplacements
                                            ?.tallyLedgerName
                                        }
                                      </p>
                                      <p>
                                        GSTIN: {data?.parsedReplacements?.gstin}
                                      </p>
                                      <p>
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.shipToAddress
                                        }
                                      </p>
                                    </div>
                                    <div>
                                      <p>
                                        <span className='boldText'>
                                          Ship To
                                        </span>
                                      </p>
                                      <p>
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.consigneeAddress
                                        }
                                        {', '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.consigneeCity
                                        }{' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.shipToAddress
                                        }{' '}
                                        {data?.parsedReplacements?.shipping_zip}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* <h3
                      style={{
                        borderBottom: "1px solid black",
                        paddingBottom: "10px",
                      }}
                    >
                      3. Goods Details
                    </h3> */}
                                <div
                                  className='boldText p-1'
                                  style={{
                                    borderBottom: '1px solid black',
                                    paddingBottom: '10px',
                                  }}
                                >
                                  3. Goods Details
                                </div>
                                <table className='goodsTable'>
                                  <thead>
                                    <tr>
                                      <th className='border-right-0'>
                                        HSN Code
                                      </th>
                                      <th className='border-right-0'>
                                        Product Name & Desc
                                      </th>
                                      <th className='border-right-0'>
                                        Quantity
                                      </th>
                                      <th className='border-right-0'>
                                        Taxable Amt
                                      </th>
                                      <th className='border-right-0'>
                                        Tax Rate(C + S)
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data?.parsedReplacements?.products?.map(
                                      (product) => (
                                        <tr>
                                          <td>
                                            <span className='boldText'>
                                              310100
                                            </span>
                                          </td>
                                          <td>{product?.product_name}</td>
                                          <td>
                                            {product?.quantity}{' '}
                                            {product?.base_unit}
                                          </td>
                                          <td>
                                            <span className='boldText'>
                                              {product?.item_amount}
                                            </span>
                                          </td>
                                          <td>
                                            {
                                              data?.parsedReplacements?.itemsTax
                                                ?.cgst
                                            }
                                            {' + '}
                                            {
                                              data?.parsedReplacements?.itemsTax
                                                ?.sgst
                                            }
                                          </td>
                                        </tr>
                                      )
                                    )}

                                    <tr>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div className='invoiceSectionBorderBottom'>
                                  <div>
                                    <p>
                                      Tot. Taxable Amt :
                                      <span className='boldText'>
                                        {' '}
                                        {data?.parsedReplacements?.total -
                                          data?.parsedReplacements?.total_tax}
                                      </span>
                                    </p>
                                    <p>
                                      CGST Amt :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.itemsTax
                                            ?.cgst_amount
                                        }
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      Other Amt :
                                      <span className='boldText'></span>
                                    </p>
                                    <p>
                                      SGST Amt :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.itemsTax
                                            ?.sgst_amount
                                        }
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      Total Inv Amt :
                                      <span className='boldText'>
                                        {data?.parsedReplacements?.total}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                                {/* <h3>4. Transportation Details</h3> */}
                                <div className='boldText p-1'>
                                  4. Transportation Details
                                </div>
                                <div className='invoiceSectionBorderBottom'>
                                  <div>
                                    <p>
                                      Transporter ID :
                                      <span className='boldText'></span>
                                    </p>
                                    <p>
                                      Name :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.transporterName
                                        }
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      Doc No :
                                      <span className='boldText'>
                                        {' '}
                                        {
                                          data?.parsedReplacements?.ewayBill
                                            ?.docNo
                                        }
                                      </span>
                                    </p>
                                    <p>
                                      Date :
                                      <span className='boldText'>
                                        {' '}
                                        {moment(
                                          data?.parsedReplacements?.ewayBill
                                            ?.billDate,
                                          'YYYYMMDD'
                                        ).format('DD-MMM-YYYY')}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                {/* <h3>4. Vehicle Details</h3> */}
                                <div className='boldText p-1'>
                                  4. Vehicle Details
                                </div>
                                <div className='invoiceSectionBorderBottom border-bottom-0'>
                                  <p>
                                    Vehicle No :
                                    <span className='boldText'>
                                      {' '}
                                      {
                                        data?.parsedReplacements?.ewayBill
                                          ?.vehicleNumber
                                      }
                                    </span>
                                  </p>
                                  <p>
                                    From :
                                    <span className='boldText'>
                                      {
                                        data?.parsedReplacements?.ewayBill
                                          ?.consignorCity
                                      }
                                    </span>
                                  </p>
                                  <p>
                                    CEBW No. :<span className='boldText'></span>
                                  </p>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewOrderInvoice;
